/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ILdsFooterViewProps } from './lds-footer';
import { FooterImageLink } from './components/FooterImageLink';
import { FooterLinks } from './components/FooterLinks';
import { FooterLegal } from './components/FooterLegal';
import { lDSPublisherPolicyAsync } from '../../actions/DataActionExtension.g';

export default (props: ILdsFooterViewProps) => {
    // const [policyInfo, setPolicyInfo] = React.useState<any>();
    const [privacyInfo, setPrivacyInfo] = React.useState<any>();
    const [privacyTitle, setPrivacyTitle] = React.useState<any>();
    const [salesInfo, setSalesInfo] = React.useState<any>();
    const [salesTitle, setSalesTitle] = React.useState<any>();
    const [termsInfo, setTermsInfo] = React.useState<any>();
    const [termsTitle, setTermsTitle] = React.useState<any>();
    const [impressumInfo, setImpressumInfo] = React.useState<any>();
    const [impressumTitle, setImpressumTitle] = React.useState<any>();
    const policies: any = props.data.policy?.result;

    let privacyPolicy: any;
    let salesAndRefundPolicy: any;
    let termsOfUse: any;
    let impressum: any;
    const Links = props.config;

    const PRIVACY_POLICY_ID = process.env.PRIVACY_POLICY_ID;
    const SALES_AND_REFUND_ID = process.env.SALES_AND_REFUND_ID;
    const TERMS_OF_USE_ID = process.env.TERMS_OF_USE_ID;

    //CRP 1
    // const privacyPolicy = 5637145327
    // const salesAndRefundPolicy = 5637144576
    // const termsOfUse = 5637145326

    //CRP 2
    // const privacyPolicy = 5637149076
    // const salesAndRefundPolicy = 5637149077
    // const termsOfUse = 5637149078

    policies?.map((policy: any) => {
        if (
            policy.Id === parseInt(PRIVACY_POLICY_ID || '', 10) ||
            policy.POLICYTYPE?.includes('Privacy Notice') ||
            policy.PolicyType?.includes('Privacy Notice')
        ) {
            privacyPolicy = policy;
        }
        if (
            policy.Id === parseInt(SALES_AND_REFUND_ID || '', 10) ||
            policy.POLICYTYPE?.includes('Sales and Refund') ||
            policy.PolicyType?.includes('Sales and Refund') ||
            policy.PolicyType?.includes('Sales & Refund') ||
            policy.PolicyType?.includes('Terms of Use and Sale')
        ) {
            salesAndRefundPolicy = policy;
        }
        if (
            policy.Id === parseInt(TERMS_OF_USE_ID || '', 10) ||
            policy.POLICYTYPE?.includes('Global Terms of Use') ||
            policy.PolicyType?.includes('Global Terms of Use') ||
            policy.PolicyType?.includes('Return Policy')
        ) {
            termsOfUse = policy;
        }
        if (policy.POLICYTYPE?.includes('Impressum') || policy.PolicyType?.includes('Impressum')) {
            impressum = policy;
        }
    });

    const getSalesData = async (policy: string) => {
        const ctx = { callerContext: props.context.actionContext };
        // let results: any;

        const results = await lDSPublisherPolicyAsync(ctx, policy).catch((err: any) => {
            console.log(err);
        });

        if (results) {
            sessionStorage.setItem('salesData', results.Title || '');
            setSalesInfo(results);
        } else {
            sessionStorage.setItem('salesData', '');
            setSalesInfo('');
        }

        return results;
    };
    const getTermsData = async (policy: string) => {
        const ctx = { callerContext: props.context.actionContext };
        // let results: any;

        const results = await lDSPublisherPolicyAsync(ctx, policy).catch((err: any) => {
            console.log(err);
        });

        if (results) {
            sessionStorage.setItem('termsData', results.Title || '');
            setTermsInfo(results);
        } else {
            sessionStorage.setItem('termsData', '');
            setTermsInfo('');
        }

        return results;
    };
    const getPrivacyData = async (policy: string) => {
        const ctx = { callerContext: props.context.actionContext };
        // let results: any;

        const results = await lDSPublisherPolicyAsync(ctx, policy).catch((err: any) => {
            console.log(err);
        });

        if (results) {
            sessionStorage.setItem('privacyData', results.Title || '');
            setPrivacyInfo(results);
        } else {
            sessionStorage.setItem('privacyData', '');
            setPrivacyInfo('');
        }

        return results;
    };
    const getImpressumData = async (policy: string) => {
        const ctx = { callerContext: props.context.actionContext };
        // let results: any;

        const results = await lDSPublisherPolicyAsync(ctx, policy).catch((err: any) => {
            console.log(err);
        });

        if (results) {
            sessionStorage.setItem('impressumData', results.Title || '');
            setImpressumInfo(results);
        } else {
            sessionStorage.setItem('impressumData', '');
            setImpressumInfo('');
        }

        return results;
    };

    React.useEffect(() => {
        const salesInfo = sessionStorage.getItem('salesData');
        const impressumInfo = sessionStorage.getItem('impressumData');
        const termsInfo = sessionStorage.getItem('termsData');
        const privacyInfo = sessionStorage.getItem('privacyData');
        const countryInfo = sessionStorage.getItem('countryFooter');
        const localeInfo = sessionStorage.getItem('localeFooter');

        if (
            salesAndRefundPolicy &&
            termsOfUse &&
            privacyPolicy &&
            impressum &&
            !salesInfo &&
            !termsInfo &&
            !privacyInfo &&
            !salesInfo &&
            !impressumInfo
        ) {
            sessionStorage.setItem('localeFooter', props.context.request.locale);
            sessionStorage.setItem('countryFooter', JSON.stringify(props.context.request.channel?.CountryRegionId));
            void getSalesData(salesAndRefundPolicy.PolicyType);
            void getTermsData(termsOfUse.PolicyType);
            void getPrivacyData(privacyPolicy.PolicyType);
            void getImpressumData(impressum.PolicyType);
        } else if (salesAndRefundPolicy && termsOfUse && privacyPolicy && !salesInfo && !termsInfo && !privacyInfo && !salesInfo) {
            void getSalesData(salesAndRefundPolicy.PolicyType);
            void getTermsData(termsOfUse.PolicyType);
            void getPrivacyData(privacyPolicy.PolicyType);
        } else if (
            localeInfo !== props.context.request.locale ||
            countryInfo !== JSON.stringify(props.context.request.channel?.CountryRegionId)
        ) {
            sessionStorage.setItem('localeFooter', props.context.request.locale);
            sessionStorage.setItem('countryFooter', JSON.stringify(props.context.request.channel?.CountryRegionId));
            if (salesAndRefundPolicy) {
                void getSalesData(salesAndRefundPolicy.PolicyType);
            } else {
                sessionStorage.setItem('salesData', '');
            }
            if (termsOfUse) {
                void getTermsData(termsOfUse.PolicyType);
            } else {
                sessionStorage.setItem('termsData', '');
            }
            if (privacyPolicy) {
                void getPrivacyData(privacyPolicy.PolicyType);
            } else {
                sessionStorage.setItem('privacyData', '');
            }
            if (impressum) {
                void getImpressumData(impressum.PolicyType);
            } else {
                sessionStorage.setItem('impressumData', '');
            }
        }
        if (salesInfo) {
            setSalesTitle(salesInfo);
        } else {
            setSalesTitle('');
        }
        if (termsInfo) {
            setTermsTitle(termsInfo);
        } else {
            setTermsTitle('');
        }
        if (privacyInfo) {
            setPrivacyTitle(privacyInfo);
        } else {
            setPrivacyTitle('');
        }
        if (impressumInfo) {
            setImpressumTitle(impressumInfo);
        } else {
            setImpressumTitle('');
        }
    }, [salesInfo, termsInfo, privacyInfo, impressumInfo]);

    const onClick = async (policyType: string) => {
        const encodedString = encodeURIComponent(policyType);

        window.open(`${window.location.origin}${props.context.request.sitePath}/termsandconditions?policy=${encodedString}`);
    };
    return (
        <>
            <div className={props.config.footerInfo ? 'footerWrapperWithInfo' : 'footerWrapper'}>
                <div id='consent_blackbar'></div>
                <FooterLinks
                    salesAndRefundPolicy={salesAndRefundPolicy}
                    impressum={impressum}
                    impressumTitle={impressumTitle}
                    salesTitle={salesTitle}
                    Links={Links}
                    resources={props.resources}
                    config={props.config}
                    onClick={onClick}
                    context={props.context}
                />
                <FooterImageLink Links={Links} />
                <FooterLegal
                    termsOfUse={termsOfUse}
                    privacyPolicy={privacyPolicy}
                    termsTitle={termsTitle}
                    privacyTitle={privacyTitle}
                    resources={props.resources}
                    config={props.config}
                    onClick={onClick}
                />
            </div>
        </>
    );
};
